import { gql } from '@apollo/client';

/**
 * 获取某仓路线邮编编辑状态：是否灰度仓、是否「更新运单数据中」、各业务类型刷数进度。
 * 前端据此决定渲染灰度新 UX 还是原即改即生效 UX，并在更新中时轮询。
 */
export const GET_ROUTE_ZIPCODE_EDIT_STATUS = gql`
    query GetRouteZipcodeEditStatus($warehouseId: Long!) {
        getRouteZipcodeEditStatus(warehouseId: $warehouseId) {
            isGrayWarehouse
            updateInProgress
            bizResults {
                bizType
                result
            }
        }
    }
`;

export interface RouteZipcodeBizResult {
    bizType: number;
    result: string;
}

export interface RouteZipcodeEditStatus {
    isGrayWarehouse: boolean;
    updateInProgress: boolean;
    bizResults: RouteZipcodeBizResult[];
}

export interface GetRouteZipcodeEditStatusResponse {
    getRouteZipcodeEditStatus: RouteZipcodeEditStatus;
}

export interface GetRouteZipcodeEditStatusVariables {
    warehouseId: number;
}
